import {createBrowserRouter} from "react-router-dom";
import RootLayout from "../pages/Root";
import ErrorPage from "../pages/Error";
import HomePage from "../pages/Home";
import AdminRootLayout from "../pages/admin/Root";
import AdminHomePage from "../pages/admin/Home";
import CategoriesPage from "../pages/admin/Categories";
import ProductsPage from "../pages/admin/Products";
import MenuSortingPage from "../pages/admin/MenuSorting";
import AuthenticationPage from "../pages/Authentication";
// import ComingSoonPage from "../pages/ComingSoon";

const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout/>,
        errorElement: <ErrorPage />,
        children: [
            // {
            //     index: true,
            //     element: <ComingSoonPage />
            // },
            // {
            //     path: 'menu',
            //     element: <HomePage />
            // }
            {
                index: true,
                element: <HomePage />
            }
        ]
    },
    {
        path: 'admin',
        element: <AdminRootLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <AdminHomePage />
            },
            {
                path: 'categorie',
                element: <CategoriesPage />
            },
            {
                path: 'prodotti',
                element: <ProductsPage />
            },
            {
                path: 'ordina-menu',
                element: <MenuSortingPage />
            }
        ]
    },
    {
        path: 'auth',
        element: <AuthenticationPage />,
        errorElement: <ErrorPage />
    }
])

export default router;